import Config from 'conf';
import { Logger } from 'data/common';
import eventsProducts from '../eventsSocket';

const { EventEmitter } = require('events');
const util = require('util');

let middleware_socket = null,
    io = require('socket.io-client'),
    socket_connected = false,
    middleware_config = {
        host: null,
        options: {},
        port: null,
        protocol: 'http'
    };

function SocketMiddleware(_environment, _dispatch, _getState, token) {
    return initConnexion.call(this, _environment, _dispatch, _getState, token);
}

const initConnexion = function initConnexion(_environment, _dispatch, _getState, token) {
    if (_dispatch && _getState && token) {
        EventEmitter.call(this);
        this.environment = _environment;
        this.dispatch = _dispatch;
        this.getState = _getState;

        this.timeout_connexion = setTimeout(() => {
            this.emit('cnx_error', 'timeout_connexion');
            this.dispatch({ type: `${this.environment.toUpperCase()}__MIDDLEWARE_SET_CONNEXION_STATE`, state: 'disconnected' });
        }, Config.timeout_socket);

        this.dispatch({ type: `${this.environment.toUpperCase()}__MIDDLEWARE_SET_CONNEXION_STATE`, state: 'pending' });
        this.socket = io(`${middleware_config.protocol}://${middleware_config.host}:${middleware_config.port}`, {
            timeout: 30000,
            ...middleware_config.options,
            query: 'type=client&authid=' + token
        });

        Logger.debug(
            `${this.environment} : Lancement de la connexion au Middleware ${middleware_config.protocol}://${middleware_config.host}:${middleware_config.port}`,
            {
                timeout: 30000,
                ...middleware_config.options,
                query: 'type=client&authid=' + token
            }
        );
        let eventsSocket = eventsProducts(this);

        Object.keys(eventsSocket).map(fctKey => {
            this[fctKey] = eventsSocket[fctKey];
        });

        this.bindSocketEvents();
    }
};
util.inherits(SocketMiddleware, EventEmitter);

SocketMiddleware.prototype.socketEmit = function(event, params) {
    if (this.socket && socket_connected) {
        try {
            this.socket.emit(event, params);
            Logger.debug(`${this.environment} : Socket Event Emitted "${event}" --->`, params);
        } catch (e) {
            Logger.debug(`${this.environment} : Error emit socket event "${event}"`, e.message);
            throw e;
        }
    } else {
        throw new Error('middlewareConnectionBreak');
    }
};

SocketMiddleware.prototype.bindSocketEvents = function() {
    let self = this;

    if (!self.socket) {
        Logger.debug(`${self.environment} : Problème, la socket n'existe pas vraiment !`);
        return false;
    }

    this.socketOn('error', function() {
        if (self.timeout_connexion) clearTimeout(self.timeout_connexion);
        const error_code = arguments[0].message || arguments[0];
        Logger.error(`${self.environment} : Error Middleware`, error_code);
        self.dispatch({ type: `${self.environment.toUpperCase()}__MIDDLEWARE_SET_CONNEXION_STATE`, state: 'disconnected' });
    });

    this.socketOn('connect', function() {
        socket_connected = true;
        clearTimeout(self.timeout_connexion);
        self.timeout_connexion = null;
        Logger.debug(`${self.environment} : La socket est créée`);
        self.emit('connected');
        self.dispatch({ type: `${self.environment.toUpperCase()}__MIDDLEWARE_SET_CONNEXION_STATE`, state: 'connected' });
    });

    this.socketOn('connected', function() {
        Logger.debug(`${self.environment} : L'application vient de se connecter au middleware`);
    });

    this.socketOn('disconnect', function() {
        socket_connected = false;
        Logger.debug(`${self.environment} : L'application vient de se déconnecter du middleware`);
        self.emit('disconnect');
        self.dispatch({ type: `${self.environment.toUpperCase()}__MIDDLEWARE_SET_CONNEXION_STATE`, state: 'disconnected' });
    });
};

SocketMiddleware.prototype.socketOn = function socketOn(event, callback) {
    if (this.socket) {
        this.socket.on(event, callback);
    }
};

SocketMiddleware.prototype.disconnect = function() {
    try {
        if (this.socket) {
            this.socket.disconnect();
        } else {
            Logger.debug(`${this.environment} : Impossible de déconnecter la socket`);
        }
    } catch (e) {
        Logger.warn(`${this.environment} : ${e}`);
    }
    this.socket = null;
};

SocketMiddleware.prototype.off = function(event, func) {
    if (this.socket) {
        this.socket.removeListener(event, func);
    }
};

SocketMiddleware.prototype.destroy = function() {
    try {
        Logger.debug(`${this.environment} : Destruction socketMiddleware`);
        this.dispatch({ type: `${this.environment.toUpperCase()}_MIDDLEWARE_SET_CONNEXION_STATE`, state: null });
        this.disconnect();
        middleware_socket = null;
    } catch (e) {
        Logger.warn(`${this.environment} : ${e}`);
    }
};

export default function(environment, dispatch, getState, token, _middleware_config) {
    if (_middleware_config) {
        middleware_config = _middleware_config;
    }
    if (!middleware_socket && dispatch && token) {
        middleware_socket = new SocketMiddleware(environment, dispatch, getState, token);
        Logger.debug(`${environment} : Instanciation de la socket`);
    }

    return middleware_socket;
}



// WEBPACK FOOTER //
// ./environments/genericEnv/common/SocketMiddleware.js